const index = () => import(/* webpackChunkName: "herb" */ './Index');

//2019年省级工业转型升级专项资金
export default {
  routes: [
    {
      path: '/internetTriple/2020/index',
      name: 'internet_triple_v2020_index',
      component: index,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/internet/triple/v2020/router.js